import * as React from "react";
import { IProduct } from "../models/IProduct.model";
import BasketContext from "../services/BasketContext";
import BasketService from "../services/BasketService";
import NotificationType from "./notification/NotificationType";
import useNotification from "./notification/useNotification";
import AlgoliaTracking from "../../../gulp/scripts/typescript/modules/algolia-tracking";
import Logger from "../../../gulp/scripts/typescript/modules/logger";

function ProductCard(props: IProduct) {

	const basketService = new BasketService();
	const basketContext = React.useContext(BasketContext);
	const { addNotification } = useNotification();
	const [isLoading, setIsLoading] = React.useState(false);
	const productCardRef = React.useRef<any>(null);

	React.useEffect(() => {
		if (productCardRef.current) {
			productCardRef.current.product = JSON.parse(props.ModelJson);
			productCardRef.current.addButtonOnBasketClick = (e) => handleAddProductToBasket(e);
		}
	}, [props.ModelJson]);

	function handleAddProductToBasket(e: React.MouseEvent) {
		setIsLoading(true);

		basketService.addProduct(props, 1)
		.then(()=>basketService.getBasket())
		.then((data)=> {
			basketContext.setBasket(data);
			setIsLoading(false);
		})
		.catch((error: Error)=> {
			addNotification({
				headline: 'Adding the product to your basket was unsuccessful. Please try again.',
				type: NotificationType.error
			});
			setIsLoading(false);
			Logger.trackException(error, 'Unknown error adding product to basket in basket');
		});

		AlgoliaTracking.addedToCart(
			[props.Guid],
			[{
				price: props.Price.Price,
				quantity: 1
			}],
			props.Price.Price
		);
	}

	return (
			<product-card
				ref={productCardRef}
				isLoading={isLoading}
				showAddButtonOnBasket
				hideSiblings
				addButtonOnBasketTest="upsell-product-add-to-basket"
				type="basket-you-may-also-like"
				test="you-may-also-like-product"
				info="Products.React"
			></product-card>
	);

}

export default ProductCard;
